import React from 'react';
import { Box, Grid } from '@mui/material';
import Card from '../common/card';

function InfoCard({ data }) {
    return (
        <Grid container spacing={3}>
            {
                data.map((item, index) => (
                    <Grid item xs={12} 
                    sm={12}
                    md={12}
                    lg={4}
                    xl={4} key={index}
                    >
                        <Card key={index} title={item.title} number={item.number} />
                    </Grid>

                ))
            }
        </Grid>
    );
}

export default InfoCard;
